module.exports = "<contractor-invoice-item-page></contractor-invoice-item-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/contractorInvoiceItem.html
// module id = 2046
// module chunks = 0